import { Link } from "react-router-dom";
import { PageTitle } from "@/components/site/PageTitle";
import { LAVORI } from "@/lib/data";

export default function LavoraConNoi() {
  return (
    <div data-testid="lavora-page">
      <PageTitle title="Lavora con noi" crumbs={[{ label: "Lavora con noi" }]} />
      <div className="max-w-[1240px] mx-auto px-4 pt-10">
        <div className="max-w-[920px] space-y-10">
          {LAVORI.map((j) => (
            <div key={j.t} className="border-b border-gray-300 pb-8">
              <h2 className="font-tit font-bold text-[var(--iv)] uppercase text-2xl mb-3">{j.t}</h2>
              <p className="leading-7">{j.d}</p>
              <Link to={`/contatti?oggetto=${encodeURIComponent(`Candidatura - ${j.t}`)}`} data-testid={`candidati-${j.t.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="inline-block mt-4 bg-[var(--iv)] text-white font-bold px-4 py-2 rounded-[3px] hover:bg-[var(--iv-dark)]">
                Candidati ora
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
